export enum EFirstMessageStatus {
  Pending = 'pending',
  Sent = 'sent',
  NeedCaptcha = 'needCaptcha',
  NeedConfirmPhone = 'needConfirmPhone',
  Failed = 'firstMessageFailed',
  ChatsBlocked = 'chatsBlocked',
  ChatsDisabled = 'chatsDisabled',
  ValidationError = 'validationError',
}
